module.exports = __webpack_public_path__ + "static/media/sdc-old-flowchart-1.ac88fd81.png";